import React, { useState } from "react";
import classNames from "classnames/bind";
import { SearchBlack } from "../../../../components/Icons/Icons";
import { SelectBox, SelectBoxItem } from "../../../../components";
import useFetchData from "../../../../hooks/useFetchData";
import styles from "./ModalCamera.module.css";

const cx = classNames.bind(styles);
const Filter = ({ setCommune, setDistrict, setProvince, setNameCamera, setStatus }) => {
  const [provinceCode, setProvinceCode] = useState({ code: null, name: "" });
  const [input, setInput] = useState()
  const [districtCode, setDistrictCode] = useState({ code: null, name: "" });
  const [communeCode, setCommuneCode] = useState({ code: null, name: "" });

  const province = useFetchData("province/get-info-province/", {
    nation_code: "VNM",
  });
  const district = useFetchData(
    `district/get-list-district/?province_code=${provinceCode.code}`
  );
  const commune = useFetchData(
    `commune/get-list-commune/?district_code=${districtCode.code}`
  );

  const onChangeProvince = (data) => {
    const index = province.data.findIndex(item => item.PROVINCE_CODE === data)
    const name = province.data[index].PROVINCE_NAME
    setProvinceCode({ code: data, name: name })
    setProvince(data)
    setDistrict('')
    setCommune('')
    setDistrictCode({ code: null, name: 'Tất cả' })
    setCommuneCode({ code: null, name: 'Tất cả' })
  }
  const onChangeDistrict = (data) => {
    const index = district.data.findIndex(item => item.DISTRICT_CODE === data)
    const name = district.data[index].DISTRICT_NAME
    setDistrictCode({ code: data, name: name })
    setDistrict(data)
    setCommune('')
    setCommuneCode({ code: null, name: 'Tất cả' })
  }
  const onChangeCommune = (data) => {
    const index = commune.data.findIndex(item => item.COMMUNE_CODE === data)
    const name = commune.data[index].COMMUNE_NAME
    setCommuneCode({ code: data, name: name })
    setCommune(data)
  }
  const onChangeStatus = (data) => {
    setStatus(data)
  }

  const handleChangeSearch = (value) => {
    setInput(value);
    setTimeout(() => {
      setNameCamera(value)
    }, 1000)
  }
  return (
    <div className={cx("filter")}>
      <div className={cx("search")}>
        <input value={input} className={cx("search-input")} placeholder="Tìm kiếm..." onChange={(e) => handleChangeSearch(e.target.value)} />
        <span className={cx("icon-search")}>
          <SearchBlack />
        </span>
      </div>
      <div>
        <label className={cx("label")}>Tỉnh</label>
        <SelectBox
          style={{ paddingTop: 8 }}
          type="small"
          className={cx("select")}
          onChange={onChangeProvince}
          values={provinceCode.name}
        >
          {province.data &&
            province.data.map((item, index) => (
              <SelectBoxItem
                label={item.PROVINCE_NAME}
                value={item.PROVINCE_CODE}
                key={index}
              />
            ))}
        </SelectBox>
      </div>

      <div>
        <label className={cx("label")}>Huyện</label>
        <SelectBox
          style={{ paddingTop: 8 }}
          type="small"
          className={cx("select")}
          onChange={onChangeDistrict}
          values={districtCode.name}
        >
          {district.data &&
            district.data.map((item, index) => (
              <SelectBoxItem
                label={item.DISTRICT_NAME}
                value={item.DISTRICT_CODE}
                key={index}
              />
            ))}
        </SelectBox>
      </div>
      <div>
        <label className={cx("label")}>Xã</label>
        <SelectBox
          style={{ paddingTop: 8 }}
          type="small"
          className={cx("select")}
          onChange={onChangeCommune}
          values={communeCode.name}
        >
          {commune.data &&
            commune.data.map((item, index) => (
              <SelectBoxItem
                label={item.COMMUNE_NAME}
                value={item.COMMUNE_CODE}
                key={index}
              />
            ))}
        </SelectBox>
      </div>
      <div>
        <label className={cx("label")}>Trạng thái</label>
        <SelectBox
          style={{ paddingTop: 8 }}
          type="small"
          className={cx("select")}
          onChange={onChangeStatus}
        >
          <SelectBoxItem value="On" label="Đang hoạt động" />
          <SelectBoxItem value="Off" label="Không hoạt động" />
        </SelectBox>
      </div>
    </div>
  );
};

export default Filter;
